import * as tslib_1 from "tslib";
import OptionsForm from './OptionsForm';
import { getStore } from 'owa-options-store';
import { observer } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var styles = require('./OptionsFull.scss');
var OptionsPane = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPane, _super);
    function OptionsPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionFormRefs = {};
        return _this;
    }
    OptionsPane.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (ref) { return (_this.settingsForm = ref); }, className: styles.settingsForm }, this.props.options.map(function (option) { return (React.createElement(OptionsForm, { option: option, key: option.key, ref: function (ref) { return (_this.optionFormRefs[option.key] = ref); } })); })));
    };
    OptionsPane.prototype.componentDidMount = function () {
        this.scrollToSelectedOption();
    };
    OptionsPane.prototype.componentDidUpdate = function (prevProps) {
        if (this.props !== prevProps) {
            // We changed options, so reset the scroll position
            this.scrollToSelectedOption();
        }
    };
    OptionsPane.prototype.scrollToSelectedOption = function () {
        var selectedOption;
        var currentOptionKey = getStore().currentOptionKey;
        if (currentOptionKey && (selectedOption = this.optionFormRefs[currentOptionKey])) {
            this.settingsForm.scrollTop = ReactDOM.findDOMNode(selectedOption).offsetTop;
        }
        else {
            this.settingsForm.scrollTop = 0;
        }
    };
    OptionsPane = tslib_1.__decorate([
        observer
    ], OptionsPane);
    return OptionsPane;
}(React.Component));
export default OptionsPane;
//# sourceMappingURL=OptionsPane.js.map